import {
  CORE_LOAD_USERS_REQUEST,
  CORE_LOAD_USERS_SUCCESS,

  CORE_LOAD_USER_INFO_REQUEST,
  CORE_LOAD_USER_INFO_SUCCESS,

  CORE_SCANQR_REQUEST,
  CORE_SCANQR_SUCCESS,
  CORE_SCANQR_FAILURE

} from '../../types'

const initialState = []
export default {
  users: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_USERS_REQUEST:
        return initialState
      case CORE_LOAD_USERS_SUCCESS:
        if (action.payload[0]) {
          const payload = action.payload[0]
          let user = []
          for (let i = 0; i < payload.length; i++) {
            user.push({ value: payload[i]._id, key: i, text: payload[i].fullName })
          }
          return user
        } else
          return [{ value: 0, key: 0, text: 0 }]

      default:
        return state
    }
  },
  userInfo: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_USER_INFO_REQUEST:
        return {}
      case CORE_LOAD_USER_INFO_SUCCESS:
        return action.payload
      default:
        return {}
    }
  },
  qrcode: (state = initialState, action) => {
    switch (action.type) {
      case CORE_SCANQR_REQUEST:
        return {}
      case CORE_SCANQR_SUCCESS:
        return action.payload
      case CORE_SCANQR_FAILURE:
        return action.payload
      default:
        return {}
    }
  },
}


// WEBPACK FOOTER //
// ./src/front/features/qrcode/reducer.js